@if (popupMenuItem.enabled) {
  @if (popupMenuItem.separator) {
    <hr />
  }
  @if (!!popupMenuItem.link) {
    @if (popupMenuItem.isHrefLink) {
      <div
        class="popup-menu-item {{typePopup}}"
        [ngClass]="popupMenuItem.klass"
        title="{{ text }}">
        <i class="fa-fw {{popupMenuItem.icon}}"
          [ngClass]="popupMenuItem.klass"
        aria-hidden="true"></i>
        <a [href]="popupMenuItem.link" target="_blank">
          <span class="text">{{ text }}</span>
        </a>
      </div>
    }
    @if (!popupMenuItem.isHrefLink) {
      <div
        class="popup-menu-item {{typePopup}}"
        [ngClass]="popupMenuItem.klass"
        routerLink="{{ popupMenuItem.link }}"
        routerLinkActive="active"
        title="{{ text }}"
        (click)="linkClick()">
        <i class="fa-fw {{popupMenuItem.icon}}"
          [ngClass]="popupMenuItem.klass"
        aria-hidden="true"></i>
        <span class="text">{{ text }}</span>
      </div>
    }
  } @else {
    <div class="popup-menu-item {{typePopup}}"
      [ngClass]="popupMenuItem.klass"
      title="{{ text }}"
      (click)="ctaClick($event)">
      <i class="fa-fw {{popupMenuItem.icon}}"
        [ngClass]="popupMenuItem.klass"
      aria-hidden="true"></i>
      <span class="text">{{ text }}</span>
    </div>
  }
} @else {
  @if (popupMenuItem.separator) {
    <hr />
  }
  <div class="popup-menu-item disabled {{typePopup}}">
    <i class="fa-fw"
      [ngClass]="popupMenuItem.icon"
    aria-hidden="true"></i>
    <span class="text">{{ text }}</span>
  </div>
}
